"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = void 0;
var getLocation = function (href) {
    var match = href.match(
    // eslint-disable-next-line no-useless-escape
    /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return (match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        path: match[5],
        search: match[6],
        hash: match[7],
    });
};
var getPath = function (href) {
    var location = getLocation(href);
    var path = location.path;
    if (path.endsWith('/')) {
        path = path.slice(0, -1);
    }
    var hash = location.hash;
    if (hash) {
        path += hash.split("?")[0];
    }
    return path;
};
exports.getPath = getPath;
//# sourceMappingURL=route-utils.js.map